import styled from "styled-components";
import { Palette } from "../../theme";
import { CardCssProps, CardProps } from "./PropelCard.types";

export interface CardPropsExtended extends CardProps {
  theme?: Palette;
}

export const PropelCard = styled.div<any>`
  position: relative;
  border-radius: 0.5rem;
  background-color: ${(props: CardCssProps) => props.theme!.colorWhite};
  padding: 1rem;
  box-sizing: border-box;
  margin: 1rem 1rem;
  box-shadow: ${(props: CardProps) =>
    props.type === "Elevated" ? "0 0 0.6rem rgba(0, 0, 0, 0.2)" : "0"};
  border: 0.1rem solid
    ${(props: CardPropsExtended) =>
      props.type === "Outlined" && props
        ? props.theme!.colorPrimaryLight
        : "none"};
`;
